export const EDIT_RENEWAL_CONTRACT_STATUS_MODAL_NAME =
  'EDIT_RENEWAL_CONTRACT_STATUS_MODAL_NAME';
